import TitleBarMenuItem from "../../../components/layout/title_bar/TitleBarMenuItem";
import ImageUploader from "../../../components/forms/image_uploader/ImageUploader";
import TitleBarSpacer from "../../../components/layout/title_bar/TitleBarSpacer";
import TitleBarTitle from "../../../components/layout/title_bar/TitleBarTitle";
import TitleBarMenu from "../../../components/layout/title_bar/TitleBarMenu";
import { useCreateArtwork, useGetArtworks } from "../../../api/query_hooks";
import Thumbnail from "../../../components/images/thumbnail/Thumbnail";
import TitleBar from "../../../components/layout/title_bar/TitleBar";
import TagInput from "../../../components/forms/tag_input/TagInput";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { getArtworkImageUrl } from "../../../api/endpoints";
import Panel from "../../../components/layout/panel/Panel";
import { useEffect, useRef, useState } from "react";

const ArtworkGallery = () => {
    
    const artworksQuery = useGetArtworks();


    return (
        <Panel>
            {artworksQuery.isLoading && 
                <div className="bg-black d-flex justify-content-center align-items-center container">
                    <Spinner animation="border" role="status" aria-describedby="loading" />
                </div>
            }
            {artworksQuery.isError && <></>}
            {artworksQuery.isSuccess &&
                <>
                    <TitleBar className="bg-dark my-2 rounded">
                        <TitleBarSpacer width={3} />
                        <TitleBarTitle>Artwork gallery</TitleBarTitle>
                        <TitleBarMenu>
                            <TitleBarMenuItem>
                                <box-icon color='white' name='select-multiple'></box-icon>
                                <span>Select</span>
                            </TitleBarMenuItem>
                        </TitleBarMenu>
                    </TitleBar>
                    <div className="d-flex flex-wrap col-12 mb-4">
                        {(artworksQuery.isSuccess) &&
                        artworksQuery.data?.data.map((artwork, index) => {
                            return(
                                <Thumbnail
                                    key={index}
                                    as="link"
                                    to={artwork.code && './'+artwork.code}
                                    src={artwork.images?.length ? getArtworkImageUrl(artwork.images[0].path) : process.env.PUBLIC_URL+"/default_artwork.png"}
                                    className="position-relative p-1 w-33 w-lg-25 border-black border-2 rounded-3 overflow-hidden user-select-none"
                                />
                            )
                        })}
                    </div>
                </>
            }
            <AddArtworkButton />
        </Panel>
    );
}


const AddArtworkButton = () => {
    const [show, setShow] = useState(false);
    const [step, setStep] = useState(0);

    const [title, setTitle] = useState("");
    const [author, setAuthor] = useState("");
    const [type, setType] = useState("");
    const [technique, setTechnique] = useState("");
    const [size, setSize] = useState("");
    const [year, setYear] = useState(0);
    const [description, setDescription] = useState("");
    const [images, setImages] = useState([]);
    const [tags, setTags] = useState([]);

    const submitButtonRef = useRef();
    
    const mutation = useCreateArtwork();

    const createArtwork = (e) => {
        e.preventDefault();

        const fd = new FormData();
        fd.append("title", title);
        fd.append("author", author);
        fd.append("type", type);
        fd.append("technique", technique);
        fd.append("size", size);
        fd.append("year", year);
        fd.append("description", description);
        tags.forEach((tag, _) => {
            fd.append("tags[]", tag);
        });
        images.forEach((image, _) => {
            fd.append("images", image);
        });

        mutation.mutate(fd);

        setShow(false);
    };

    useEffect(() => {
        if(mutation.isSuccess && !mutation.isError) {
            setShow(false);
        }
    }, [mutation.isSuccess, mutation.isError]);


    return (
        <>
            <Modal size="lg" show={show} fullscreen="md-down" centered onHide={() => setShow(false)}>
                <Modal.Header className="bg-dark rounded-md-top" closeButton>
                    <Modal.Title>Add new artwork</Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-dark">
                    <Form encType="multipart/form-data" onSubmit={createArtwork} >

                        {step === 0 &&
                            <>
                                <div className="col-12 d-flex flex-column flex-md-row gap-md-4 gap-lg-5 justify-content-center">
                                    <Form.Group className="mb-3 d-flex flex-column col-md-4" controlId="titleBox" >
                                        <Form.Label className="ms-3">Title</Form.Label>
                                        <Form.Control className="bg-darker" type="text" placeholder="Title of the artwork" onChange={e => setTitle(e.target.value)} aria-describedby="title" />
                                    </Form.Group>

                                    <Form.Group className="mb-3 d-flex flex-column col-md-4" controlId="authorBox" >
                                        <Form.Label className="ms-3">Author</Form.Label>
                                        <Form.Control className="bg-darker" type="text" placeholder="Author name" onChange={e => setAuthor(e.target.value)} aria-describedby="author" />
                                    </Form.Group>

                                    <Form.Group className="mb-3 d-flex flex-column col-3 col-md-2" controlId="yearBox" >
                                        <Form.Label className="ms-3">Year</Form.Label>
                                        <Form.Control className="bg-darker" type="number" onChange={e => setYear(e.target.value)} aria-describedby="year" />
                                    </Form.Group>
                                </div>

                                <div className="col-12 d-flex flex-column flex-md-row gap-md-4 gap-lg-5 justify-content-center">
                                    <Form.Group className="mb-3 d-flex flex-column col-md-4" controlId="typeBox" >
                                        <Form.Label className="ms-3">Artwork type</Form.Label>
                                        <Form.Select className={"bg-darker text-light border-black"} onChange={e => setType(e.target.value !== "Select" ? e.target.value : "")} aria-label="select type">
                                            <option className="text-light">Select</option>
                                            <option value="painting">Painting</option>
                                            <option value="digital painting">Digital painting</option>
                                            <option value="photograph">Photograph</option>
                                        </Form.Select>
                                    </Form.Group>

                                    <Form.Group className="mb-3 d-flex flex-column col-md-3" controlId="techniqueBox" >
                                        <Form.Label className="ms-3">Technique</Form.Label>
                                        <Form.Control className="bg-darker" type="text" placeholder="oil on canvas/airbrushing/sampling/..." onChange={e => setTechnique(e.target.value)} aria-describedby="technique" />
                                    </Form.Group>

                                    <Form.Group className="col-md-3 mb-3" controlId="sizeBox" >
                                            <Form.Label className="ms-3">size (cm, px, ...)</Form.Label>
                                            <div className="d-flex gap-2">
                                                <Form.Control className="bg-darker" type="text" placeholder="size" onChange={e => setSize(e.target.value)} aria-describedby="size" />
                                            </div>
                                    </Form.Group>
                                </div>

                                <Form.Group className="mb-3 d-flex flex-column ms-md-3 pe-md-4 col-md-12" controlId="descriptionBox" >
                                    <Form.Label className="ms-3">Description</Form.Label>
                                    <Form.Control className="bg-darker" as={"textarea"} placeholder="Brief descrption of the artwork" onChange={e => setDescription(e.target.value)} aria-describedby="description" />
                                </Form.Group>
                            </>
                        }
                        {step === 1 &&
                            <div className="d-flex flex-column">
                                <ImageUploader label="Add images" className="d-flex flex-column mt-2 mb-3 ms-md-3 pe-md-4 col-md-12" images={images} setImages={setImages} fileLimit={8} />
                                <TagInput className="my-3 ms-md-3 pe-md-4 col-12" tags={tags} setTags={setTags} />
                            </div>
                        }

                        <Button type="submit" className="hidden" ref={submitButtonRef} />
                        
                    </Form>
                </Modal.Body>
                <Modal.Footer className="bg-dark justify-content-between gap-2 rounded-md-bottom">
                    <Button variant="dark" className="border-secondary" onClick={() => setShow(false)} >
                        <span>Cancel</span>
                    </Button>
                    {step === 0 &&
                        <Button variant="warning" className="px-4 px-lg-3" type="button" onClick={() => setStep(1)} aria-describedby="next">
                            <span className="text-dark">Next</span>
                        </Button>
                    }
                    {step === 1 &&
                        <div className="d-flex gap-3">
                            <Button variant="dark" className="border-secondary" type="button" onClick={() => setStep(0)} aria-describedby="back">
                                <span>Back</span>
                            </Button>
                            <Button variant="warning" className="px-4 px-lg-3" type="button" onClick={() => submitButtonRef.current.click()} aria-describedby="save" disabled={mutation.isFetching}>
                                {mutation.isFetching && <Spinner size="sm" animation="border" role="status" />}
                                {!mutation.isFetching && <span className="text-dark">Save</span>}
                            </Button>
                        </div>
                    }
                </Modal.Footer>
            </Modal>
            <Button variant="link" className="position-absolute bottom-0 end-0 d-flex p-0 m-5" onClick={() => setShow(true)} aria-describedby="new collection" >
                <box-icon name='plus-circle' size='lg' type='solid' color='#ffc107' ></box-icon>
            </Button>
        </>
    );
}


export default ArtworkGallery;